/**
 * Pre-compiled de messages for PasswordInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { hide: `Passwort ausblenden`, show: `Passwort anzeigen` };
